import { all, call, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants/index';
import { network } from './network';


export function* getPages() {
  yield call(network, 'page', 'index',
    ActionTypes.PAGE_GET_SUCCESS,
    ActionTypes.PAGE_GET_FAILURE,
    {},
  );
}

export function* refreshPages() {
  yield call(network, 'page', 'index',
    ActionTypes.PAGE_REFRESH_SUCCESS,
    ActionTypes.PAGE_REFRESH_FAILURE,
    {},
  );
}

export function* addPage() {
  yield call(network, 'page', 'create',
    ActionTypes.PAGE_ADD_SUCCESS,
    ActionTypes.PAGE_ADD_FAILURE,
    {},
  );
}

export function* addTutorialPage() {
  yield call(network, 'page', 'create/tutorial',
    ActionTypes.PAGE_TUTORIAL_ADD_SUCCESS,
    ActionTypes.PAGE_TUTORIAL_ADD_FAILURE,
    {},
  );
}

export function* deletePage({ payload }) {
  const { pageUrlsafe }  = payload;
  yield call(network, 'page', 'delete',
    ActionTypes.PAGE_DELETE_SUCCESS,
    ActionTypes.PAGE_DELETE_FAILURE,
    { pageUrlsafe },
  );
}

export function* updatePageAttr({ payload }) {
  const { pageUrlsafe, changes } = payload;
  yield call(network,
    'page', 'update',
    ActionTypes.PAGE_UPDATE_SUCCESS,
    ActionTypes.PAGE_UPDATE_FAILURE,
    { pageUrlsafe, changes },
  );
}

export function* checkPageSubdomainAvailability({ payload }) {
  const { pageUrlsafe, subdomain } = payload;
  yield call(network,
    'page', 'subdomain/available',
    ActionTypes.PAGE_CHECK_SUBDOMAIN_SUCCESS,
    ActionTypes.PAGE_CHECK_SUBDOMAIN_FAILURE,
    {
      pageUrlsafe,
      subdomain,
    },
  );
}

export function* addPageVariant({ payload }) {
  const { pageUrlsafe } = payload;
  yield call(network, 'variant', 'create',
    ActionTypes.PAGE_VARIANT_ADD_SUCCESS,
    ActionTypes.PAGE_VARIANT_ADD_FAILURE,
    { pageUrlsafe },
  );
}

export function* updatePageVariantAttr({ payload }) {
  yield call(network, 'variant', 'update',
    ActionTypes.PAGE_VARIANT_UPDATE_SUCCESS,
    ActionTypes.PAGE_VARIANT_UPDATE_FAILURE,
    { ...payload }
  );
}

export function* deletePageVariant({ payload }) {
  const { pageUrlsafe, variantUrlsafe } = payload;
  yield call(network, 'variant', 'delete',
    ActionTypes.PAGE_VARIANT_DELETE_SUCCESS,
    ActionTypes.PAGE_VARIANT_DELETE_FAILURE,
    {
      pageUrlsafe: pageUrlsafe,
      variantUrlsafe: variantUrlsafe,
    }
  );
}

export function* cloneVariant({ payload }) {
  const { pageUrlsafe, variantUrlsafe } = payload;
  yield call(network, 'variant', 'clone',
    ActionTypes.PAGE_VARIANT_CLONE_SUCCESS,
    ActionTypes.PAGE_VARIANT_CLONE_FAILURE,
    {
      pageUrlsafe: pageUrlsafe,
      variantUrlsafe: variantUrlsafe,
    }
  );
}

export default function* root() {
  yield all([
    takeLatest(ActionTypes.PAGE_GET_REQUEST, getPages),
    takeLatest(ActionTypes.PAGE_REFRESH_REQUEST, refreshPages),
    takeLatest(ActionTypes.PAGE_ADD_REQUEST, addPage),
    takeLatest(ActionTypes.PAGE_TUTORIAL_ADD_REQUEST, addTutorialPage),
    takeLatest(ActionTypes.PAGE_UPDATE_REQUEST, updatePageAttr),
    takeLatest(ActionTypes.PAGE_CHECK_SUBDOMAIN_REQUEST, checkPageSubdomainAvailability),
    takeLatest(ActionTypes.PAGE_DELETE_REQUEST, deletePage),

    takeLatest(ActionTypes.PAGE_VARIANT_ADD_REQUEST, addPageVariant),
    takeLatest(ActionTypes.PAGE_VARIANT_UPDATE_REQUEST, updatePageVariantAttr),
    takeLatest(ActionTypes.PAGE_VARIANT_DELETE_REQUEST, deletePageVariant),
    takeLatest(ActionTypes.PAGE_VARIANT_CLONE_REQUEST, cloneVariant),
  ]);
}



// WEBPACK FOOTER //
// ./scripts/sagas/page.js